import request from '@/utils/request'

/* banner列表*/
export function bannerlist() {
  return request({
    url: `${process.env.VUE_APP_PARJECT_NAME}/index/list/banner`,
    method: 'post',
    data: {
      
    }
  })
}

/* 合作方案列表*/
export function planlist() {
  return request({
    url: `${process.env.VUE_APP_PARJECT_NAME}/index/list/CooperationProgramme`,
    method: 'post',
    data: {
      
    }
  })
}

/* 合作伙伴列表*/
export function partnerlist() {
  return request({
    url: `${process.env.VUE_APP_PARJECT_NAME}/index/list/partner`,
    method: 'post',
    data: {
      
    }
  })
}

/* 开发引导列表*/
export function devGuidelist() {
  return request({
    url: `${process.env.VUE_APP_PARJECT_NAME}/index/list/devGuide`,
    method: 'post',
    data: {
      
    }
  })
}


// WEBPACK FOOTER //
// ./src/services/api/index.js